import React, { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";
import Icon from "../../../components/AppIcon";
import { useNavigate } from "react-router-dom";
const BootcampList = () => {

  const [bootcamps, setBootcamps] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {

    const loadBootcamps = async () => {

      const res = await api.get("/api/bootcamp/bootcamps");
      setBootcamps(res.data);

    };

    loadBootcamps();

  }, []);

  return (

    <div className="p-6">

<div className="flex items-center gap-3 mb-4">

<button
onClick={() => navigate("/admin/bootcamp")}
className="flex items-center gap-2 text-muted-foreground hover:text-primary"
>
<Icon name="ArrowLeft" size={18}/>
Back
</button>

</div>
      <h2 className="text-2xl font-bold mb-6">Bootcamps</h2>

      <div className="grid gap-4">

        {bootcamps.map((b) => (

          <div key={b._id} className="border p-4 rounded">

            <h3 className="font-bold">{b.title}</h3>

            <p>Trainer: {b.trainer}</p>

            <p>Date: {new Date(b.date).toLocaleDateString()}</p>

            <p>Seats: {b.seats}</p>
            <p>
  Feedback Link: 
  <a
    href={`/feedback/${b._id}`}
    target="_blank"
    className="text-blue-500"
  >
    Open
  </a>
</p>
<button
  onClick={() =>
    navigate(`/admin/feedback/${b._id}`)
  }
  className="text-blue-500 mt-2"
>
  View Feedback
</button>
          </div>

        ))}

      </div>

    </div>

  );
};

export default BootcampList;